import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73f5fc23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found-container" }
const _hoisted_2 = { class: "logo-container py-6" }
const _hoisted_3 = { class: "title-container text-h3 pb-3" }
const _hoisted_4 = { class: "text-container pb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.appStore.isSessionInitialized)
        ? (_openBlock(), _createBlock(_component_v_img, {
            key: 0,
            class: "my-2",
            "max-width": "150",
            src: require('@/assets/logos/gorate-logo-white.svg'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('Dashboard')))
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('i18n.pageNotFoundTitle')), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('i18n.pageNotFoundSubtitle')), 1),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('i18n.homepageLinkText')), 1)
      ]),
      _: 1
    })
  ]))
}